import * as React from "react";

import theme from "@ui/themes/default";

import { style, Icon } from "./Symbolicons";

export const PageContent = (props: Icon): React.ReactElement => (
  <svg
    style={{ ...style(props.size, props.height), ...props.style }}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <defs>
      <path
        d="M12.667 4c.035 0 .07.003.104.008l.018.003a.642.642 0 01.261.11c.031.022.06.047.088.074l-.06-.053a.67.67 0 01.05.043l.01.01 5.333 5.334a.667.667 0 01.196.471l-.006-.086.001.008.005.078v8a2 2 0 01-2 2H7.333a2 2 0 01-2-2V6a2 2 0 012-2h5.334zm-.668 1.333H7.333A.666.666 0 006.667 6v12c0 .368.298.667.666.667h9.334a.667.667 0 00.666-.667v-7.334h-4.666a.667.667 0 01-.663-.588L12 10V5.333zm3.334 10a.667.667 0 01.078 1.33l-.078.004H8.667a.667.667 0 01-.078-1.33l.078-.004h6.666zm0-2.666a.667.667 0 01.078 1.329l-.078.004H8.667a.667.667 0 01-.078-1.329l.078-.004h6.666zm1.057-3.334l-3.057-3.056v3.056h3.057z"
        id="page_content_a"
      />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="page_content_b" fill="#fff">
        <use xlinkHref="#page_content_a" />
      </mask>
      <use fill="#FFF" fillRule="nonzero" xlinkHref="#page_content_a" />
      <g
        mask="url(#page_content_b)"
        fill={props.color || theme.palette.grey600}
      >
        <path d="M0 0h24v24H0z" />
      </g>
    </g>
  </svg>
);
